var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "position-x": _vm.positionX,
        "position-y": _vm.positionY,
        absolute: "",
        "offset-y": "",
        "close-on-content-click": false,
        "close-on-click": false,
        "z-index": 15,
        "data-testid": "histogram-popup",
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "histogram-card",
          attrs: { "data-testid": "histogram-card" },
        },
        [
          _c("div", { staticClass: "histogram-header" }, [
            _c(
              "div",
              {
                staticClass: "histogram-title",
                attrs: { "data-testid": "histogram-title" },
              },
              [_vm._v("\n        " + _vm._s(_vm.itemLabel) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "histogram-count",
                attrs: { "data-testid": "histogram-count" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("total_count", { count: _vm.totalCount })) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "histogram-svg",
              attrs: {
                width: _vm.chartWidth,
                height: _vm.chartHeight,
                viewBox: "0 0 " + _vm.chartWidth + " " + _vm.chartHeight,
              },
            },
            [
              _vm._l(_vm.histogramData, function (count, hour) {
                return _c("rect", {
                  key: hour,
                  attrs: {
                    "data-testid": "histogram-bar",
                    x: _vm.chartPaddingLeft + hour * _vm.barStep,
                    y:
                      _vm.chartHeight - _vm.chartPadding - _vm.barHeight(count),
                    width: _vm.barWidth,
                    height: _vm.barHeight(count),
                    fill: "#CC0000",
                    "fill-opacity": "0.7",
                  },
                })
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: _vm.chartPaddingLeft,
                  y1: _vm.chartPadding,
                  x2: _vm.chartPaddingLeft,
                  y2: _vm.chartHeight - _vm.chartPadding,
                  stroke: "#ccc",
                  "stroke-width": "1",
                },
              }),
              _vm._v(" "),
              _c(
                "text",
                {
                  attrs: {
                    "data-testid": "histogram-y-label",
                    x: _vm.chartPaddingLeft - 4,
                    y: _vm.chartPadding + 4,
                    "text-anchor": "end",
                    "font-size": "10",
                    fill: "#666",
                  },
                },
                [_vm._v("\n        " + _vm._s(_vm.yAxisMax) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "text",
                {
                  attrs: {
                    "data-testid": "histogram-y-label",
                    x: _vm.chartPaddingLeft - 4,
                    y: _vm.chartHeight - _vm.chartPadding,
                    "text-anchor": "end",
                    "font-size": "10",
                    fill: "#666",
                  },
                },
                [_vm._v("\n        0\n      ")]
              ),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: _vm.chartPaddingLeft,
                  y1: _vm.chartHeight - _vm.chartPadding,
                  x2: _vm.chartWidth - _vm.chartPadding,
                  y2: _vm.chartHeight - _vm.chartPadding,
                  stroke: "#ccc",
                  "stroke-width": "1",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.axisLabels, function (label) {
                return _c(
                  "text",
                  {
                    key: "label-" + label,
                    attrs: {
                      x:
                        _vm.chartPaddingLeft +
                        label * _vm.barStep +
                        _vm.barWidth / 2,
                      y: _vm.chartHeight - 2,
                      "text-anchor": "middle",
                      "font-size": "10",
                      fill: "#666",
                    },
                  },
                  [_vm._v("\n        " + _vm._s(label) + "\n      ")]
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }